import React from 'react';
import { Link } from 'react-router-dom';

export default function CheckoutCancel() {
  return (
    <div className="container" style={{ maxWidth: 480, margin: '0 auto', textAlign: 'center', padding: '80px 16px' }}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>❌</div>
      <h1 style={{ marginBottom: 8 }}>Payment Cancelled</h1>
      <p style={{ color: '#6b7280', marginBottom: 32 }}>
        Your payment was cancelled. Your cart is still saved — you can try again anytime.
      </p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        <Link to="/cart" className="btn btn-primary">Return to Cart</Link>
        <Link to="/shop" className="btn btn-outline">Continue Shopping</Link>
      </div>
    </div>
  );
}
